/**
 * Capitalises the first letter of each word and lowercases the rest,
 * e.g. "FAIRFIELD PUBLIC SCHOOLS" → "Fairfield Public Schools".
 */
export function capitalizeWords(str: string) {
  return str.replace(
    /\w\S*/g,
    (text: string) =>
      text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}
